import { ProductTableCopyButton } from './ProductTableCopyButton';

export default ProductTableCopyButton;